import React from 'react'

import { VALUE_PLACEHOLDER } from '@app/constants/valuePlaceholder'

import { LabelValueRow } from './components'

import styles from './styles.module.scss'

import type { CSSProperties } from 'react'
import type { LabelValueTableProps } from './types'

export const LabelValueTable: React.FC<LabelValueTableProps> = ({
  data,
  hasSeparator,
  columns = 1,
  fallbackValue = VALUE_PLACEHOLDER.doubleDash
}) => {
  const style: CSSProperties = { gridTemplateColumns: `repeat(${columns}, 1fr)` }

  return (
    <div
      className={ styles.table }
      style={ style }
    >
      { data?.map(rowData => (
        <LabelValueRow
          key={ rowData.label }
          hasSeparator={ hasSeparator }
          fallbackValue={ fallbackValue }
          { ...rowData }
        />
      )) }
    </div>
  )
}
